// extracted by mini-css-extract-plugin
export var wrapper = "allPages-module--wrapper--2uSjn";
export var containerMain = "allPages-module--containerMain--3Vjbo";
export var descriptionContainer = "allPages-module--descriptionContainer--3Jv5Y";
export var title = "allPages-module--title--2ewAl";
export var desc = "allPages-module--desc--TJkRn";
export var slideImage = "allPages-module--slideImage--L7N7o";
export var carouselContainer = "allPages-module--carouselContainer--3hTkk";
export var swiperButtonNext = "allPages-module--swiper-button-next--1JmB4";
export var swiperButtonPrev = "allPages-module--swiper-button-prev--3Z7Os";